var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeedconfigurator/viewmodels/index',["require", "exports", "models/portal", "services/trace", "common/viewmodelbase", "areas/activityfeedconfigurator/service/activityfeedconfigurator-service", "areas/activityfeedconfigurator/service/billingemail-service", "areas/activityfeedconfigurator/models/bindable", "areas/activityfeedconfigurator/models/dto", "models/account"], function (require, exports, Portal, traceSvc, common, service, billingService, model, dto, Account) {
    "use strict";
    var ActivityFeedConfiguratorViewModel = (function (_super) {
        __extends(ActivityFeedConfiguratorViewModel, _super);
        function ActivityFeedConfiguratorViewModel() {
            var _this = this;
            _super.call(this);
            this.portalOptions = new Array();
            this.cchDailyOptions = new Array();
            this.toggleAddProfiles = false;
            this.toggleAddEmails = false;
            this.toggleAddHashtags = false;
            this.profileInput = "";
            this.hashtagInput = "";
            this.emailInput = "";
            this.profileList = [];
            this.hashtagList = [];
            this.emailList = [];
            this.settingsVisibility = false;
            this.emailVisibility = false;
            this.option = "";
            this.emptyArray = false;
            this.dialogMessage = "";
            this.zeroState = true;
            this.isAdmin = false;
            this.primaryEmail = "";
            this.screenWidth = $(window).width();
            this.$window = $(window);
            this.toggleProfiles = function () {
                _this.toggleAddProfiles = !_this.toggleAddProfiles;
            };
            this.toggleHashtags = function () {
                _this.toggleAddHashtags = !_this.toggleAddHashtags;
            };
            this.toggleEmails = function () {
                if (_this.emailList.length >= 6) {
                    _this.showDialog('You have reached the maximum number of email addresses. Please delete another email address before adding a new one.');
                }
                else {
                    _this.toggleAddEmails = !_this.toggleAddEmails;
                    if (_this.emailList.length === 0)
                        _this.zeroState = false;
                }
            };
            this.addProfiles = function (profileInput) {
                if (profileInput !== "") {
                    if (!(_this.profileList.indexOf(profileInput) > -1)) {
                        _this.profileList.push(profileInput);
                    }
                    else {
                        traceSvc.traceInformation("Profile: " + profileInput + " already exists.");
                    }
                }
                _this.toggleAddProfiles = false;
                _this.profileInput = "";
            };
            this.removeProfiles = function (profile) {
                var index = _this.profileList.indexOf(profile, 0);
                if (index > -1) {
                    _this.profileList.splice(index, 1);
                }
            };
            this.addHashtags = function (hashtagInput) {
                if (hashtagInput !== "") {
                    if (!(_this.hashtagList.indexOf(hashtagInput) > -1)) {
                        _this.hashtagList.push(hashtagInput);
                    }
                    else {
                        traceSvc.traceInformation("Hashtag: " + hashtagInput + " already exists.");
                    }
                }
                _this.toggleAddHashtags = false;
                _this.hashtagInput = "";
            };
            this.removeHashtags = function (hashtag) {
                var index = _this.hashtagList.indexOf(hashtag, 0);
                if (index > -1) {
                    _this.hashtagList.splice(index, 1);
                }
            };
            this.addEmails = function (emailInput) {
                if (emailInput !== "") {
                    if (!(_this.emailList.indexOf(emailInput) > -1)) {
                        if (_this.emailList.length === 0)
                            _this.primaryEmail = emailInput;
                        var email = new dto.BillingEmailEntity(emailInput, _this.emailList.length === 0);
                        _this.emailList.push(email);
                    }
                    else {
                        traceSvc.traceInformation("Email: " + emailInput + " already exists.");
                    }
                }
                _this.toggleAddEmails = false;
                _this.emailInput = "";
                if (_this.emailList.length === 0)
                    _this.zeroState = true;
            };
            this.enterAddEmail = function (d, e) {
                e.keyCode === 13 && _this.enterExecution();
                return true;
            };
            this.enterExecution = function () {
                if (_this.toggleAddEmails && _this.emailInput !== "" && _this.validateEmail(_this.emailInput))
                    _this.addEmails(_this.emailInput);
            };
            this.removeEmail = function (emailToDelete) {
                if (emailToDelete.EmailAddress !== _this.primaryEmail) {
                    _this.emailList.remove(emailToDelete);
                    if (_this.emailList.length === 0)
                        _this.zeroState = true;
                }
                else {
                    _this.showDialog('This email address is the primary email address for your practice. Please select another primary email address before deleting this one.');
                }
            };
            this.changePrimary = function (index) {
                if (_this.primaryEmail === _this.emailList[index].EmailAddress) {
                    var aux = new dto.BillingEmailEntity(_this.emailList[index].EmailAddress);
                    _this.emailList.splice(index, 1, aux);
                }
            };
            this.validateEmail = function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            };
            ko.track(this, ["portalOptions", "cchDailyOptions", "toggleAddHashtags", "toggleAddProfiles",
                "profileList", "hashtagList", "profileInput", "hashtagInput", "settingsVisibility",
                "emailList", "option", "toggleAddEmails", "emailInput", "emailVisibility", "dialogMessage", "zeroState", "primaryEmail", "isAdmin", "screenWidth"]);
            this.configuratorService = new service.ActivityFeedConfiguratorService();
            this.billingService = new billingService.BillingService();
            var self = this;
            this.$window.resize(function () {
                self.screenWidth = self.$window.width();
            });
        }
        ActivityFeedConfiguratorViewModel.prototype.onActivated = function (context) {
            //if (!this._initialized) {
            //    this._initialized = true;
            //    window.setTimeout(() => { this.loadData(); }, 200);
            //}
            this.loadData();
        };
        ActivityFeedConfiguratorViewModel.prototype.loadData = function () {
            this.pageRefresh();
            this.getUserOptions();
            this.getBillingDetails();
            this.getSourcePage(window.location.href);
            this.userIsAdmin();
        };
        ActivityFeedConfiguratorViewModel.prototype.getSourcePage = function (url) {
            var sourceString = url.substring(url.indexOf('?') + 1);
            var id = sourceString.substring(sourceString.lastIndexOf('=') + 1);
            this.sourcePage = id;
            if (id == "1")
                this.settingsVisibility = true;
            else {
                this.settingsVisibility = false;
            }
        };
        ActivityFeedConfiguratorViewModel.prototype.userIsAdmin = function () {
            if (Account.Principal.current.memberType === 'stb_admin') {
                this.isAdmin = true;
            }
        };
        ActivityFeedConfiguratorViewModel.prototype.getUserOptions = function () {
            var _this = this;
            this.configuratorService.getUserOptions()
                .then(function (activityFeedServiceModel) {
                //this.hashtagList = activityFeedServiceModel.SocialMediaOptions.Hashtags;
                for (var i = 0; i < activityFeedServiceModel.SocialMediaOptions.Hashtags.length; i++) {
                    if (activityFeedServiceModel.SocialMediaOptions.Hashtags[i] != "") {
                        _this.hashtagList.push(activityFeedServiceModel.SocialMediaOptions.Hashtags[i]);
                    }
                }
                //this.profileList = activityFeedServiceModel.SocialMediaOptions.Profiles;
                for (var i = 0; i < activityFeedServiceModel.SocialMediaOptions.Profiles.length; i++) {
                    if (activityFeedServiceModel.SocialMediaOptions.Profiles[i] != "") {
                        _this.profileList.push(activityFeedServiceModel.SocialMediaOptions.Profiles[i]);
                    }
                }
                for (var i = 0; i < activityFeedServiceModel.PortalOptions.length; i++) {
                    var item = _this.createSettingsGenericEntity(activityFeedServiceModel.PortalOptions[i]);
                    _this.portalOptions.push(item);
                }
                for (var i = 0; i < activityFeedServiceModel.CchDailyOptions.length; i++) {
                    var item = _this.createSettingsGenericEntity(activityFeedServiceModel.CchDailyOptions[i]);
                    _this.cchDailyOptions.push(item);
                }
            });
        };
        ActivityFeedConfiguratorViewModel.prototype.createSettingsGenericEntity = function (entity) {
            var item = new dto.SettingsGenericEntity();
            item.Label = entity.Label;
            item.Selected = entity.Selected;
            item.Key = entity.Key;
            return item;
        };
        ActivityFeedConfiguratorViewModel.prototype.setUserOptions = function () {
            if (this.settingsVisibility) {
                var data = new model.ActivityFeedConfiguratorVM();
                // social media
                data.socialMediaOptions = new dto.SocialMediaOptions();
                data.socialMediaOptions.Hashtags = this.hashtagList;
                data.socialMediaOptions.Profiles = this.profileList;
                // portal options
                data.portalOptions = this.portalOptions;
                // cch daily options
                data.cchDailyOptions = this.cchDailyOptions;
                this.taskManager.startAsync("Saving activity feed settings...", function () {
                    return Portal.Context.shell.userManager.saveSettings("activity-feed", data);
                });
                traceSvc.traceInformation("Activity feed settings has been successfully saved.");
            }
            if (this.emailVisibility) {
                this.postBillingDetails();
            }
        };
        ActivityFeedConfiguratorViewModel.prototype.getBillingDetails = function () {
            var _this = this;
            var organizationId = this.activeOrganization.organizationId;
            this.primaryEmail = "";
            this.emailInput = "";
            this.toggleAddEmails = false;
            this.billingService.get(organizationId).then(function (response) {
                _this.emailList = response.map(function (e) {
                    if (e.primaryEmail) {
                        _this.primaryEmail = e.emailAddress;
                        return null;
                    }
                    return new dto.BillingEmailEntity(e.emailAddress, e.sendInvoices);
                }).filter(function (e) { return e !== null; });
                _this.zeroState = true;
                if (_this.emailList.length > 0 || _this.primaryEmail !== "") {
                    _this.zeroState = false;
                    _this.emailList.unshift(new dto.BillingEmailEntity(_this.primaryEmail));
                }
            });
        };
        ActivityFeedConfiguratorViewModel.prototype.postBillingDetails = function () {
            var _this = this;
            var organizationId = this.activeOrganization.organizationId;
            var emails = this.emailList.filter(function (e) { return e.EmailAddress !== _this.primaryEmail; });
            emails.unshift(new dto.BillingEmailEntity(this.primaryEmail));
            this.billingService.post(organizationId, emails)
                .then(function (data) {
                traceSvc.traceInformation("Charging and billing notifications settings has been successfully saved.");
            })
                .fail(function (error) {
                traceSvc.traceError(error.responseText);
                console.log(error.responseText);
            });
        };
        ActivityFeedConfiguratorViewModel.prototype.revertChanges = function () {
            this.portalOptions = [];
            this.cchDailyOptions = [];
            this.hashtagList = [];
            this.profileList = [];
            this.emailList = [];
            this.getUserOptions();
            this.getBillingDetails();
        };
        ActivityFeedConfiguratorViewModel.prototype.changeSettingsVisibility = function (param) {
            if (param == "activityFeed") {
                this.settingsVisibility = !this.settingsVisibility;
            }
            else if (param == "billingEmail") {
                this.emailVisibility = !this.emailVisibility;
            }
        };
        ActivityFeedConfiguratorViewModel.prototype.pageRefresh = function () {
            this.portalOptions = [];
            this.cchDailyOptions = [];
            this.profileInput = "";
            this.hashtagInput = "";
            this.emailInput = "";
            this.profileList = [];
            this.hashtagList = [];
            this.emailList = [];
        };
        ActivityFeedConfiguratorViewModel.prototype.showDialog = function (message) {
            this.dialogMessage = message;
            document.getElementById("emailmodal").style.display = "block";
        };
        ActivityFeedConfiguratorViewModel.prototype.closeDialog = function () {
            document.getElementById("emailmodal").style.display = "none";
        };
        return ActivityFeedConfiguratorViewModel;
    }(common.ListViewModelBase));
    var instance = new ActivityFeedConfiguratorViewModel();
    return instance;
});

